<template>
  <div>
    <div class="print-only" v-html="this.html"></div>
    <div class="screen-only">
      <div :class="[{ 'expanded' : isExpanded }, textClass]" v-html="displayText"></div>
      <a v-show="text.length > maxChars" @click="toggleExpanded" :class="{ 'expanded' : isExpanded }">
        {{ toggleExpandLinkText }}
      </a>
    </div>
  </div>
</template>

<script>
import clip from "text-clipper";

export default {
  props: {
    text: { type: String, required: true, default: '' },
    html: { type: String, required: false, default: '' },
    maxChars: { type: Number, required: true, default: 100 },
    maxLines: { type: Number, required: true, default: 3 },
    showMoreText: { type: String, required: false, default: 'more' },
    showLessText: { type: String, required: false, default: 'less' },
    parseLinks: { type: Boolean, required: false, default: false },
    textClass: { type: String, required: false, default: 'text' }
  },

  data() {
    return {
      isExpanded: false
    }
  },

  computed: {
    displayText() {
      if (this.isExpanded) {
        return this.html !== '' ? this.html : this.text;
      } else {
        if (this.text.length > this.maxChars) {
          if (this.html !== '') {
            return clip(this.html, this.maxChars, { html: true, maxLines: this.maxLines });
          } else {
            return clip(this.text, this.maxChars);
          }
        } else {
          return this.html !== '' ? this.html : this.text;
        }
      }
    },
     toggleExpandLinkText() {
      return this.isExpanded ? this.showLessText : this.showMoreText;
    }
  },

  methods: {
    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
    }
  }
}
</script>

<style lang="scss" scoped>
  .print-only {
    display: none;
    text-align: justify;
  }
  a {
    font-size: 0.8rem;
    cursor: s-resize;
    &.expanded {
      cursor: n-resize;
    }
  }

  @media print {
    .print-only {
      display: block;
    }

    .screen-only {
      display: none;
    }
  }
</style>
